<template>
  <div class="rc-textarea-container" :class="{'disabled-rc-input': disabled}">
    <template v-if="floatLabel">
      <label
        class="rc-floating-label"
        :class="{
          'rc-label-active': isFocused || localValue,
          'rc-label-centered': !isFocused && !localValue,
        }"
      >
        {{ label }}
      </label>
    </template>
    <textarea
      v-model="localValue"
      @blur="_onBlur($event)"
      @focus="_onFocus($event)"
      @input="_onInput($event)"
      @change="_onChange($event)"
      :maxlength="maxlength"
      :placeholder="!floatLabel ? label : ''"
      :disabled="disabled"
      :pattern="pattern"
      class="rc-textarea-field rc-default-input-styles"
      name=""
      cols="30"
      rows="10"
    ></textarea>
  </div>
</template>

<script>
export default {
  name: "RCTextArea",
  props: {
    value: {
      required: false,
    },
    label: String,
    floatLabel: Boolean,
    disabled: {
      type: Boolean,
      default: false,
    },
    pattern: {
      type: String,
      required: false,
    },
    maxlength: {
      type: Number
    }
  },
  data() {
    return {
      localValue: this.value || "",
      isFocused: false,
    };
  },
  methods: {
    _onInput(event) {
      this.$emit("input", event.target.value);
    },
    _onChange(event) {
      this.$emit("change", event.target.value);
    },
    _onBlur(event) {
      this.$emit("blur", event.target.value);
      this.isFocused = false;
    },
    _onFocus(event) {
      this.$emit("focus", event.target.value);
      this.isFocused = true;
    },
  },
};
</script>

<style scoped>
.rc-textarea-container {
  resize: both;
  position: relative;
  display: inline-block;
  align-items: center;
  width: 200px;
  padding-top: 8px;
  transition: all 0.3s;
  font-size: 16px;
  color: #888;
  border: 1px solid #939393;
  border-radius: 10px;
  background-color: white;
}

.disabled-rc-input {
  background-color: #efefef;
}


.rc-floating-label {
  position: absolute;
  top: 0;
  left: 5px;
  pointer-events: none;
  transition: all 0.2s;
  font-size: 16px;
  color: #6c757d;
}

.rc-textarea-field {
  font-size: 16px;
  height: 40px;
}

.rc-label-active {
  font-size: 12px;
  transform: translateY(-18px);
}

.rc-label-centered {
  /* top: 52%; */
  top: 20px;
  left: 5px;
  transform: translateY(-50%);
}

.hover-item-background {
  background-color: #e9ecef;
}
</style>
